import * as React from 'react';
import { cn } from '@heroui/react';

export interface ResultViewProps {
  score: number;
  totalScore: number;
  questionCount: number;
  mode?: 'trial' | 'prod';
  onRestart: () => void;
}

export function ResultView({ score, totalScore, questionCount, mode = 'trial', onRestart }: ResultViewProps) {
  const pct = totalScore > 0 ? Math.round((score / totalScore) * 100) : 0;
  const feedbackClass = pct >= 80 ? 'text-emerald-300' : pct >= 50 ? 'text-amber-300' : 'text-red-300';
  const feedbackMessage = pct >= 80 ? '表现出色' : pct >= 50 ? '继续加油' : '再接再厉';

  return (
    <div className="flex h-full w-full flex-col items-center justify-center px-6 py-10">
      <div className="relative my-8">
        <div className="absolute inset-0 animate-pulse rounded-full bg-indigo-500 opacity-20 blur-3xl" />
        <div className="relative flex h-48 w-48 flex-col items-center justify-center rounded-full border-4 border-white/12 bg-white/5 shadow-2xl backdrop-blur-md">
          <span className="mb-1 text-xs uppercase tracking-widest text-gray-400">最终得分</span>
          <span className="text-5xl font-black text-white">{score}</span>
          <span className="mt-1 text-sm text-gray-400">/ {totalScore}</span>
          <span className="mt-2 text-xs text-white/60">共 {questionCount} 题</span>
        </div>
      </div>

      <h2 className={cn('mb-2 text-4xl font-black tracking-tighter drop-shadow-lg', feedbackClass)}>{feedbackMessage}</h2>
      <p className="mb-10 max-w-xs text-center text-gray-400">挑战完成，可随时再试一轮。</p>

      {mode === 'trial' ? (
        <button
          type="button"
          onClick={onRestart}
          className="rounded-full bg-indigo-600 px-12 py-4 text-lg font-bold tracking-wide text-white shadow-[0_0_30px_rgba(79,70,229,0.5)] transition-all hover:scale-105 hover:bg-indigo-500 active:scale-95"
        >
          再玩一次
        </button>
      ) : (
        <button
          type="button"
          onClick={onRestart}
          className="rounded-full bg-indigo-600 px-12 py-4 text-lg font-bold tracking-wide text-white shadow-[0_0_30px_rgba(79,70,229,0.5)] transition-all hover:bg-indigo-500"
        >
          返回
        </button>
      )}
    </div>
  );
}
